import fire from '../fire';

const deleteEmne = async(emnekode) => {
    const db = fire.firestore()
    await db.collection('emner').doc(emnekode).delete()
    console.log("Slettet emne:", emnekode)
}

export default deleteEmne;